<template>
  <transition name="message">
    <div class="message" :class="getClass(type)">
      {{content}}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',
  methods: {
    getClass(type){
      return 'message-'+type
    }
  }
}
</script>

<style lang="less">
  .message{
    position: fixed;
    padding: 0.5rem;
    left: 50%;
    top: 0.5rem;
    transform: translate(-50%, 0);
    color: #333;
    z-index: 999;
    border-radius: .3rem;
    border: 0.01rem solid #fbc4c4;
    font-size: 0.6rem;
    &.message-error{
      color: #fff;
      background-color: #f56c6c;
    }
    &.message-success{
      color: #fff;
      background-color: #67C23A;
    }
  }
</style>